import React, { useContext, useEffect, useState } from "react";
import {
    Box, Typography, Avatar, styled,Grid,FormControlLabel,Checkbox,
    Divider, List, ListItemButton, ListItemIcon, ListItemText, Menu,
    Button
} from "@mui/material";
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import {
    KeyboardArrowDown,
    AccessibilityNewOutlined, AdminPanelSettings,Https, LogoutOutlined,PublishedWithChanges,FlipCameraAndroid
} from "@mui/icons-material";
import useUserActivity from "../../container/useUserActivity";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from 'react-router-dom';
import { getStorage, setStorage } from "../../utilities/browserStorage";
import CustomizedDialogs from "../modalWindowComponent/CustomizedDialogs";
import { DEFAULT_PAGING_SIZE, LOGIN_ROUTE, PAGING_END_INDEX, ROUTE_CHANGE_PASSWORD, ROUTE_DASHBOARD, ROUTE_MYPROFILE } from "../../utilities/staticConfigs";
import workerManager from "../authentications/tokenWorkerManager";
import authService from '../authentications/service';
import service from "./service";
import { UserProfileBoxTableBodyOnly, UserProfileBoxTableObject } from "./UserProfileBoxTable";
import { checkPermission, clearIndexedDb, extractPermissions, getPathToRouteOnLoginToAdminModule, getPathToRouteOnLoginToPractice, stringToColor } from "../../utilities/commonUtilities";
import { stopNotificationWorker } from "../Notifications/worker/workerListener";
import i18n from "../../utilities/i18n";
import Pagination from "../commons/pagination";
import Table from '../commons/Table/Table';
import classes from './userprofilebox.module.css';
import { pms_staff_user_privilege, super_admin_privileges } from "../../utilities/permissions";
import TextInput from '../commons/input/input'
import LoadingContext from "../../container/loadingContext";


const searchTypeList = [
    { value: "custom_practice_id", name: i18n.t("switchPractice.practiceId") },
    { value: "practice_name", name: i18n.t("switchPractice.practiceName") },
    { value: "custom_provider_id", name: i18n.t("switchPractice.providerId") },
    { value: "provider_name", name: i18n.t("switchPractice.providerName") },
    { value: "custom_facility_id", name: i18n.t("switchPractice.facilityId") },
    { value: "facility_name", name: i18n.t("switchPractice.facilityName") },
    { value: "custom_patient_id", name: i18n.t("switchPractice.patientId") },
    { value: "patient_name", name: i18n.t("switchPractice.patientName") },
    { value: "custom_claim_id", name: i18n.t("switchPractice.claimId") },
    { value: "payment_id", name: i18n.t("switchPractice.paymentId") },
    { value: "npi", name: i18n.t("switchPractice.npi") }
]

const UserProfileBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: '4px 8px',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius * 2,
    cursor: 'pointer',
    '&:hover': { backgroundColor: theme.palette.action.hover },
}));

const StyledMenu = styled((props) => (
    <Menu
        elevation={0}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        {...props}
    />
))(({ theme }) => ({
    zIndex: '3000 !important',
    '& .MuiPaper-root': {
        marginTop: theme.spacing(1),
        width: 280,
        borderRadius: 12,
        boxShadow: '0px 5px 15px rgba(0,0,0,0.08)',
        border: `1px solid ${theme.palette.divider}`,
        '&:before': {
            content: '""',
            display: 'block',
            position: 'absolute',
            top: 0,
            right: 18,
            width: 10,
            height: 10,
            backgroundColor: theme.palette.background.paper,
            transform: 'translateY(-50%) rotate(45deg)',
            zIndex: 0,
            borderLeft: `1px solid ${theme.palette.divider}`,
            borderTop: `1px solid ${theme.palette.divider}`,
        },
    },
}));

const ProfileMenu = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    let groupName = '';
    if (getStorage('userData')) {
        groupName = JSON.parse(getStorage('userData')).group_name;
    }

    let profileName = '';
    let uName = '';
    let profileImgTag = '';
    let profileImg = '';
    let avatar_name = '';
    let userData = getStorage('userData');
    const [anchorEl, setAnchorEl] = useState(null);
    const isMenuOpen = Boolean(anchorEl);

    const setShowLoadingBar = useContext(LoadingContext);

    const [showSwitchPracticeWindow, setShowSwitchPracticeWindow] = useState(false);
    const [customer, setCustomer] = useState("");
    const [customerDropdown, setCustomerDropdown] = useState([]);
    const [searchBy, setSearchBy] = useState("custom_practice_id");
    const [search, setSearch] = useState("");
    const [includeInactivePractice, setIncludeInactivePractice] = useState(false);
    const [defaultPractice, setDefaultPractice] = useState(groupName === "superadmin" ? true : false);
    const [tableValues, setTableValues] = useState([]);
    const [practiceName, setPracticeName] = useState(getStorage('practiceName'));
    const [practicePK, setPracticePK] = useState(getStorage('practice'));

    const [clearBtn, setClearBtn] = useState(0)
    const [customersList, setCustomersList] = useState([]);

    const [practiceSwitchFlag, setPracticeSwitchFlag] = useState(null);

    const [totalPage, setTotalPage] = useState(1);
    const [activePage, setActivePage] = useState(1);
    const [startIndex, setStartIndex] = useState(0);
    const [endIndex, setEndIndex] = useState(PAGING_END_INDEX);

    const handleProfileClick = (event) => setAnchorEl(event.currentTarget);
    const handleMenuClose = () => setAnchorEl(null);


    const { toggleTracking } = useUserActivity();

    useEffect(() => {
        return () => {
            setPracticeSwitchFlag(null);
        }
    }, [])

    useEffect(() => {
        if (location && location.state?.practiceName && !practiceName) {
            setPracticeName(location.state.practiceName);
        }
    })

    useEffect(() => {
        if (practiceSwitchFlag) {
            onSearchPractice(DEFAULT_PAGING_SIZE, activePage);
        }
    }, [activePage, defaultPractice, clearBtn, practiceSwitchFlag]);


    useEffect(() => {
        window.addEventListener('storage', handleStorageEvent);

        return () => {
            window.removeEventListener('storage', handleStorageEvent);
        };
    }, []);


    /**
        * if the sharedWorker initialized here we listen message from the sharedWorker
        */
    useEffect(() => {
        if (window.SharedWorker) {
            const handleMessage = (message) => {
                switch (message.type) {
                    case 'token_near_expiry':
                        renewToken();
                        break;
                    case 'stop_timer':
                        workerManager.clearValue();
                        toggleTracking();
                        break;
                    case 'user_inactive':
                        onLogout();
                        break;
                    default:
                        break;
                }
            };

            workerManager.addMessageListener(handleMessage);

            /**
             * If sharedWorker initialized and refreshToken exist setting the toooken and start activity and timer
             */
            const accessToken = JSON.parse(getStorage("userData") || "{}")?.accessToken;
            if (window.SharedWorker && accessToken) {
                workerManager.setTokens(accessToken);
            }

            return () => {
                workerManager.removeMessageListener(handleMessage);
            };
        }
    }, []);

    useEffect(() => {
        if (!customersList || customersList.length === 0) {
            setActivePage(1);
        }
    }, [customersList]);


    const onShowSwitchPractice = () => {
        setShowSwitchPracticeWindow(true);
        onSearchPractice(DEFAULT_PAGING_SIZE, activePage);
    }

    const resetSwitchPractice = () => {
        setShowSwitchPracticeWindow(false);
        setCustomer("");
        setSearchBy("custom_practice_id");
        setSearch("");
        setIncludeInactivePractice(false);
        setCustomersList([]);
        setTableValues([]);
    }

    /**
     * function to renew token if user is active
     */

    const renewToken = async () => {
        try {
            workerManager.postMessage({ type: 'clear_value' });
            const refreshToken = JSON.parse(getStorage("userData")).refreshToken;
            let data = {
                refresh_token: refreshToken
            }
            const result = await authService.renewTokenAPI(data);
            if (result?.data?.refresh && result?.data?.access) {
                if (window.SharedWorker) {
                    workerManager.setTokens(result?.data?.access);
                    toggleTracking();
                    const userData = JSON.parse(getStorage("userData"));
                    userData.accessToken = result.data.access;
                    userData.refreshToken = result.data.refresh;
                    localStorage.setItem('userData', JSON.stringify(userData));
                }
            } else {
                onLogout();
                workerManager.clearStorage();
                workerManager.clearValue();
                toggleTracking();
            }
        } catch (error) {
            console.error(error)
        }
    }

    const listCustomerDropdaown = (query) => {
        const result = service.GetListCustomerDropdown(query);
        result.then((response) => {
            setCustomerDropdown(response.data.results);
        });
    }

    const onHandleIncludeInactivePracticeChange = () => {
        setIncludeInactivePractice(!includeInactivePractice)
    }

    const onHandleDefaultPracticeChange = () => {
        setDefaultPractice(!defaultPractice);
    }

    const onHandleChange = (e) => {
        let name = e.target.name;
        let value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        let trimmedValue = "";
        trimmedValue = value;
        if (name === "searchBy") setSearchBy(trimmedValue);
        else if (name === "searchBox") setSearch(trimmedValue);
        else if (name === "chkIncludeInactive") setIncludeInactivePractice(trimmedValue);
    }

    const onSearchCustomer = (query) => {
        listCustomerDropdaown(query);
    }


    const onSearchPractice = (DEFAULT_PAGING_SIZE, activePage) => {
        setShowLoadingBar(true);
        let query = '?default_pratice=' + defaultPractice + '&inactive=' + includeInactivePractice + '&page=' + activePage + '&pageSize=' + DEFAULT_PAGING_SIZE;
        if (customersList.length > 0)
            query += '&customer_pk=' + customersList[0].id;
        if (searchBy.trim())
            query += '&type=' + searchBy;
        if (search.trim())
            query += '&value=' + search;
        const result = service.ListPracticesForSwitching(query);
        result.then(async (response) => {
            if (response?.data?.results !== undefined) {
                setTotalPage(Math.ceil(response.data.count / response.data.page_size));
            }
            const rowArray = await getRowData(response?.data)
            if (rowArray.length > 0) {
                UserProfileBoxTableObject.tableBodyData = rowArray;
            }
            else {
                UserProfileBoxTableObject.tableBodyData = UserProfileBoxTableBodyOnly;
            }

            setTableValues(response?.data?.results);
            setShowLoadingBar(false);
        })
    }

    const getRowData = (data) => {
        let anArray = [];
        let rowArray = [];
        if (data?.results?.length) {
            let newData = Array(data.results.length).fill(JSON.parse(JSON.stringify(UserProfileBoxTableObject.tableBodyData[0])));
            newData.forEach((row, rowIndex) => {
                row.forEach((col) => {
                    let colObject = {};
                    colObject = {
                        ...col, 'value': data.results[rowIndex][col.name],
                        "id": data.results[rowIndex].id,
                        "clickOnRowCondition": practicePK
                    }

                    anArray.push(colObject)
                })
                rowArray.push(anArray)
                anArray = [];
            });
        }
        return rowArray;
    }

    const onSelectPractice = async (e, id, name, custom_practice_id) => {
        setShowLoadingBar(true);
        const result = service.SwitchPractice({
            old_practice: parseInt(getStorage('practice')),
            new_practice: parseInt(id)
        });
        result.then(response => {
            localStorage.removeItem('custom_practice_id');
            setStorage("custom_practice_id", response?.data?.custom_practice_id);
            setStorage("enable_advance_fee_schedule", response?.data?.enable_advance_fee_schedule ?? false);
        })
        //clears indexedDb
        await clearIndexedDb();
        let selectedPracticeName = name + '(' + custom_practice_id + ')';
        localStorage.removeItem("practice");
        localStorage.removeItem("practiceName");
        let selectedPractice = id;
        setStorage("practice", selectedPractice);
        setStorage("practiceName", selectedPracticeName);
        setPracticeName(selectedPracticeName);
        setPracticePK(selectedPractice);
        resetSwitchPractice();

        /**UPDATE THE PRACTICE LEVEL SIDEBAR MENU AND PERMISSIONS */
        const practiceSideBarMenuAndPermissions = await service.GetPracticeMenuAndPermissionsOnPracticeSwitch(selectedPractice);
        const practiceModuleMenuSet = [];
        const adminModuleMenuSet = [];

        practiceSideBarMenuAndPermissions?.data?.practice_role_permissions?.forEach((item) => {
            // When the module item is of practice module
            if (item.is_super_admin_module === false) {
                // get the sub module lists for sidebar
                const subModules = item.sub_module?.map((subItem) => {
                    if (subItem?.system_generated === false) {
                        return {
                            ...subItem.ui_integration_data
                        }
                    } else {
                        return;
                    }
                });

                // Pushing the module and its sub item to practice module menu along with a dummy sub item
                // that is needed for utility 
                practiceModuleMenuSet.push({
                    ...item.ui_integration_data,
                    sub_menu:
                        subModules?.length ?
                            subModules : []
                });
            } else if (item.is_super_admin_module === true) {
                // get the sub module lists for sidebar
                const subModules = item.sub_module?.map((subItem) => {
                    if (subItem?.system_generated === false) {
                        return {
                            ...subItem.ui_integration_data
                        }
                    } else {
                        return;
                    }
                })
                // Pushing the module and its sub item to admin module menu set along with a dummy sub item
                // that is needed for utility
                adminModuleMenuSet.push({
                    ...item.ui_integration_data,
                    sub_menu: subModules?.length ?
                        subModules : []
                });
            }
        });

        // Retrieve the existing stringified object
        const storedUserDataStr = getStorage("userData"); 

        if (storedUserDataStr) {
            try {
                // Parse it into a JavaScript object
                let userDataObj = JSON.parse(storedUserDataStr);
                
                // Update the specific keys
                userDataObj.view_client_escalation = practiceSideBarMenuAndPermissions?.data?.can_view_client_escalations ?? false;
                userDataObj.initiate_client_escalation = practiceSideBarMenuAndPermissions?.data?.can_initiate_client_escalation ?? false;
                
                // Stringify and save back to local storage
                setStorage("userData", JSON.stringify(userDataObj));
            } catch (error) {
                console.error("Error updating user data in local storage:", error);
            }
        }

        // This code sets the menu's route to a sub-menu item's route if no matching route is found in sub-menu,
        //  offering a default route based on sub-menu content when conditions allow.
        practiceModuleMenuSet.forEach((menu, index) => {
            if (menu.sub_menu?.length && menu.route !== '#') {
                const defaultRoute = menu?.route;
                const defaultSubMenuAvailable = menu?.sub_menu?.findIndex((item) => item?.route === defaultRoute);

                if (defaultSubMenuAvailable === -1) {
                    const defaultSubMenuToSet = menu?.sub_menu?.find((item) => item?.route !== '#')?.route ?? menu?.route;

                    if (defaultSubMenuToSet) {
                        practiceModuleMenuSet[index].route = defaultSubMenuToSet;
                    }
                }
            }
        });

        practiceModuleMenuSet.forEach((item, index) => {
            if (!item?.sub_menu[0]) {
                practiceModuleMenuSet[index].sub_menu = []
            }
        })

        adminModuleMenuSet.forEach((item, index) => {
            if (!item?.sub_menu[0]) {
                adminModuleMenuSet[index].sub_menu = []
            }
        })

        setStorage('practiceModuleMenuSet', JSON.stringify(practiceModuleMenuSet));
        setStorage('adminModuleMenuSet', JSON.stringify(adminModuleMenuSet));
        setStorage('permissionCodeSet', JSON.stringify(extractPermissions(practiceSideBarMenuAndPermissions?.data?.practice_role_permissions, practiceSideBarMenuAndPermissions?.data?.user_role_permissions)));

        setShowLoadingBar(false);
        history.push(getPathToRouteOnLoginToPractice(practiceModuleMenuSet))
        window.location.reload();
    }
    
    const onLogout = async () => {
        setShowLoadingBar(true);
    
        try {
            //  Stop background processes first
            stopNotificationWorker(dispatch);
    
            // Call the backend Logout API first and wait for it
            // If this throws an error, the code jumps to 'finally'
            await service.LogOut();
    
        } catch (error) {
            console.error("Logout API failed:", error);
            // Note: Even if the API fails, we proceed to clear data in 'finally'
            // so the user isn't stuck.
        } finally {
            // clear the storages (after API call is finished)
            await clearIndexedDb();
            localStorage.clear();
            
            if (workerManager) {
                workerManager.clearValue();
                workerManager.clearStorage();
            }
    
            toggleTracking();
    
            // Reset all Redux states
            const resetActions = [
                'chargesDebit/onResetData', 'paymentAdjustment/onResetData',
                'openArReport/onResetData', 'transactionReport/onResetData',
                'reportFilters/reset', 'statementMgmnt/resetData',
                'patientInfo/setInitialState', 'claimManagement/resetClaimtoInitalState',
                'eraSlice/showSearchAction', 'arClaims/ResetData',
                'ClaimFilter/reset', 'batchEligibility/onResetData',
                'chatbox/reset', 'commonStates/reset', 'claimManagement/resetToInitial',
                'DropDownOptionSlice/resetToInitial', 'paymentSlice/resetToInitialState',
                'checkLevel/onResetData', 'reportGenerator/onResetData',
                'notifications/clearAllState','claimBeta/resetToInitial','mywork/resetToInitial',
                'patientbeta/resetToInitial'
            ];
    
            resetActions.forEach(actionType => dispatch({ type: actionType }));
    
            // Final UI updates and navigation
            setShowLoadingBar(false);
            history.push(LOGIN_ROUTE);
        }
    }

    const onSwitchToAdmin = () => {
        const adminModuleMenuSet = JSON.parse(localStorage.getItem('adminModuleMenuSet'));
        history.push(getPathToRouteOnLoginToAdminModule(adminModuleMenuSet));
        service.SwitchAdmin({
            practice_pk: practicePK,
        });
        setStorage('isAdminModule', true);
        window.location.reload();
    }
    const routeToMyprofile = () => {
        history.push(ROUTE_MYPROFILE)
        setAnchorEl(null)
    }

    const onSwitchToPractice = () => {
        // Instead of statically routing the user back to the practice from the admin module (e.g., history.push(ROUTE_DASHBOARD)), 
        // first determine the routes the user has access to, and then route to the appropriate one.
        const practiceModuleMenuSet = JSON.parse(localStorage.getItem('practiceModuleMenuSet'));

        if (practiceModuleMenuSet[0]?.route === ROUTE_DASHBOARD || (practiceModuleMenuSet[0]?.route !== '#' && practiceModuleMenuSet[0]?.route !== '')) {
            history.push(practiceModuleMenuSet[0]?.route);
        } else {
            // If the first module sub modules then find one from the sub module list and route to that sub module page
            const route = practiceModuleMenuSet[0]?.sub_menu.find((subMenu) => {
                return subMenu.route !== '#';
            })?.route;

            if (route) {
                history.push(route);
            }
        }
        setStorage('isAdminModule', false);
        window.location.reload();
    }

    const onChangePassword = () => {
        history.push(ROUTE_CHANGE_PASSWORD);
    }


    const onPagePrevious = () => {
        let previousPage = startIndex + 1 - PAGING_END_INDEX;
        setActivePage(previousPage);
        if (startIndex !== 0) {
            setStartIndex(startIndex - PAGING_END_INDEX);
            setEndIndex(endIndex - PAGING_END_INDEX);
        }

    }

    const onPageUp = (e) => {
        let page = Number(e.target.id)
        setActivePage(page);
    }

    const onPageNext = () => {
        let nextPage = startIndex + 1 + PAGING_END_INDEX;
        if (endIndex === totalPage || totalPage <= PAGING_END_INDEX) {
            setActivePage(nextPage);
            setStartIndex(startIndex);
            setStartIndex(endIndex);
        } else {
            setActivePage(nextPage);
            setStartIndex(startIndex + PAGING_END_INDEX);
            setEndIndex(endIndex + PAGING_END_INDEX);
        }
    }


    const selectOnTab = (e) => {
        if (e.key === "Tab") {
            document.querySelector("a.dropdown-item.active").click();
        }
    }

    const onRowClick = (e, itemId) => {
        let obj = tableValues.find(item => item.id == itemId);
        onSelectPractice(e, obj.id, obj.name, obj.custom_practice_id);
    }


    const handleStorageEvent = (event) => {

        if (event.key === 'practice') {
            // Reload the page
            window.location.reload();
        }
    }

    if (userData) {
        userData = JSON.parse(userData);
        if (userData && typeof userData === 'object' && Object.keys(userData).length > 0) {
            uName = userData.username || '';
            profileName = userData.profile_name ? userData.profile_name.trim() : '';
            profileImg = userData.profile_image || '';
            avatar_name = userData.avatar_name || '';

            if (!profileImg && avatar_name) {
                const backgroundColor = stringToColor(avatar_name);
                profileImgTag = (
                    <Avatar style={{ backgroundColor, width: 28, height: 28 }}>
                        {avatar_name[0]}
                    </Avatar>
                );
            } else if (profileImg) {
                profileImgTag = (
                    <Avatar src={profileImg} style={{ width: 28, height: 28 }} />
                );
            }
        }
    }


    return (
        <Box>
            <UserProfileBox onClick={handleProfileClick}>
                {profileImgTag}
                <KeyboardArrowDown
                    sx={{
                        color: 'text.secondary',
                        fontSize: '18px',
                        transform: isMenuOpen ? 'rotate(180deg)' : 'none',
                        transition: '0.2s'
                    }}
                />
            </UserProfileBox>

            <StyledMenu
                anchorEl={anchorEl}
                open={isMenuOpen}
                onClose={handleMenuClose}
            >
                <Box sx={{ px: 2.5, py: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Avatar src={profileImg} sx={{ width: 48, height: 48 }} />
                    <Box>
                        <Typography variant="subtitle1" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
                            {practiceName?.trim()?.substring(0, 16)}
                        </Typography>
                        <Typography variant="caption" sx={{ color: '#ed8936', fontWeight: 500 }}>
                            {(profileName?.trim()?.length > 1) ? profileName?.trim()?.substring(0, 25) : uName?.trim()?.substring(0, 25)}
                        </Typography>
                    </Box>
                </Box>

                <Divider />

                <List dense sx={{ py: 0.5 }}>
                    <ListItemButton onClick={() => routeToMyprofile()}>
                        <ListItemIcon sx={{ minWidth: 40 }}><AccessibilityNewOutlined fontSize="small" /></ListItemIcon>
                        <ListItemText primary={i18n.t("commons.myProfile")} />
                    </ListItemButton>
                    {(getStorage('isAdminModule') === 'true' && groupName === 'superadmin' && getStorage('practice')) && (
                    <ListItemButton onClick={() => { onSwitchToPractice(); setAnchorEl(null); }}>
                        <ListItemIcon sx={{ minWidth: 40 }}><PublishedWithChanges fontSize="small" /></ListItemIcon>
                        <ListItemText primary={i18n.t("commons.backToPractice")} />
                    </ListItemButton>
                    )}

                    {(getStorage('isAdminModule') === 'true' && groupName === 'staff_user' && getStorage('practice')) && (

                        <ListItemButton onClick={() => { onSwitchToPractice(); setAnchorEl(null); }}>
                        <ListItemIcon sx={{ minWidth: 40 }}><PublishedWithChanges fontSize="small" /></ListItemIcon>
                        <ListItemText primary={i18n.t("commons.backToPractice")} />
                        </ListItemButton>
                    )}

                    {getStorage('isAdminModule') === 'false' && checkPermission(super_admin_privileges.super_admin_full_privilege, pms_staff_user_privilege) && (
                        <ListItemButton onClick={() => { onSwitchToAdmin(); setAnchorEl(null); }}>
                        <ListItemIcon sx={{ minWidth: 40 }}><AdminPanelSettings fontSize="small" /></ListItemIcon>
                        <ListItemText primary={i18n.t("commons.switchToAdmin")} />
                        </ListItemButton>
                    )}

                    {getStorage('isAdminModule') === 'false' && (
                        <ListItemButton onClick={() => { onShowSwitchPractice(); setPracticeSwitchFlag(1); setAnchorEl(null); }}>
                        <ListItemIcon sx={{ minWidth: 40 }}><FlipCameraAndroid fontSize="small" /></ListItemIcon>
                        <ListItemText primary={i18n.t("switchPractice.switchPractice")} />
                        </ListItemButton>
                    )}

                    <Divider sx={{ my: 1 }} />

                    <ListItemButton sx={{ py: 0.5 }} onClick={() => { onChangePassword(); setAnchorEl(null); }}>
                        <ListItemIcon sx={{ minWidth: 40 }}><Https fontSize="small" /></ListItemIcon>
                        <ListItemText primary={i18n.t("commons.changePassword")} />
                    </ListItemButton>

                    <Divider sx={{ my: 1 }} />

                    <ListItemButton onClick={() => { onLogout(); setAnchorEl(null); }}>
                        <ListItemIcon sx={{ minWidth: 40 }}><LogoutOutlined fontSize="small" /></ListItemIcon>
                        <ListItemText primary="Log Out" />
                    </ListItemButton>
                </List>
            </StyledMenu>
            <CustomizedDialogs
                modalId={'longWidth'}
                showModal={showSwitchPracticeWindow}
                header={i18n.t("switchPractice.switchPractice")}
                setShowModalWindow={setShowSwitchPracticeWindow}
                resetForm={resetSwitchPractice}
            >
                <Box sx={{ p: 3 }}>
                    <Grid container spacing={2} alignItems="flex-end">
                        {groupName === 'superadmin' && (
                            <Grid item xs={12} md={3}>
                                <AsyncTypeahead
                                    id="basic-typeahead-single"
                                    labelKey="name"
                                    minLength={3}
                                    onChange={setCustomersList}
                                    options={customerDropdown}
                                    placeholder={i18n.t("switchPractice.selectCustomer")}
                                    onSearch={onSearchCustomer}
                                    selected={customersList}
                                    onKeyDown={(e) => selectOnTab(e)}
                                    name="customer"
                                    value={customer}
                                    clearButton={true}
                                />
                            </Grid>
                        )}

                        <Grid item xs={12} md={3}>
                            <Typography variant="body2" sx={{ mb: 0.5, color: 'text.secondary' }}>
                                {i18n.t("switchPractice.searchBy")}
                            </Typography>
                            <select
                                name="searchBy"
                                id="searchBy"
                                value={searchBy}
                                onChange={onHandleChange}
                                style={{
                                    width: '100%',
                                    height: "40px",
                                    borderRadius: '4px',
                                    borderColor: "#ced4da",
                                    padding: '0 8px'
                                }}
                            >
                                {searchTypeList.map((item, index) => (
                                    <option key={index} value={item.value}>{item.name}</option>
                                ))}
                            </select>
                        </Grid>

                        <Grid item xs={12} md={3}>
                            <Box sx={{ position: 'relative' }}>
                                <TextInput
                                    name="searchBox"
                                    type="text"
                                    label={i18n.t("switchPractice.search")}
                                    value={search}
                                    onValueChange={onHandleChange}
                                    fullWidth
                                    clearButton
                                    clearInput={() => { setSearch(''); setClearBtn(clearBtn + 1) }}
                                />
                            </Box>
                        </Grid>

                        <Grid item xs={12} md={3}>
                            <Button
                                variant="contained"
                                type="button"
                                onClick={() => { onSearchPractice(DEFAULT_PAGING_SIZE, 1); setActivePage(1); }}
                            >
                                {i18n.t("switchPractice.search")}
                            </Button>
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} sx={{ mt: 1 }}>
                        <Grid item>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        size="small"
                                        checked={includeInactivePractice}
                                        onMouseDown={e => onHandleIncludeInactivePracticeChange(e)}
                                    />
                                }
                                label={<Typography variant="body2">{i18n.t("switchPractice.inactivePractice")}</Typography>}
                            />
                        </Grid>
                        {groupName === 'superadmin' && (
                            <Grid item>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            size="small"
                                            checked={defaultPractice}
                                            onMouseDown={e => onHandleDefaultPracticeChange(e)}
                                        />
                                    }
                                    label={<Typography variant="body2">{i18n.t("switchPractice.showSelectedPractices")}</Typography>}
                                />
                            </Grid>
                        )}
                    </Grid>

                    <Box 
                        sx={{ mt: 3,
                            '& table': { tableLayout: 'fixed', width: '100%'},
                            '& table tbody tr': {cursor: 'pointer !important'}
                        }}
                        className={classes.WrapperDiv}>
                        <Table tableObject={UserProfileBoxTableObject} onRowClick={onRowClick} />
                        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
                            <Pagination
                                totalPage={totalPage}
                                activePage={activePage}
                                startIndex={startIndex}
                                endIndex={endIndex}
                                onPagePrevious={onPagePrevious}
                                onPageUp={onPageUp}
                                onPageNext={onPageNext}
                            />
                        </Box>
                    </Box>
                </Box>
            </CustomizedDialogs>
        </Box>
    );
};

export default ProfileMenu;